export function normalizeBlockedAnswerPhone(value) {
  let compact = String(value ?? "").trim().replace(/^whatsapp:/i, "");
  compact = compact.replace(/[\s().-]/g, "");

  if (!/^\+[1-9]\d{6,14}$/.test(compact)) {
    return null;
  }

  return `whatsapp:${compact}`;
}

export function formatBlockedAnswerPhone(value) {
  return String(value ?? "").replace(/^whatsapp:/i, "");
}
